import React from 'react';
import { func } from 'prop-types';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import BobConfirmButton from '../../../components/BobConfirmButton';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import * as ArchitectActions from '../../../actions/architectActions';
import * as ApplicationMessageActions from '../../../actions/applicationMessageActions';
import * as UiActions from '../../../actions/uiActions';

import classes from '../CreateEntityModal.module.css';

const DeleteEquipmentModal = ({
    clearErrors,
    deleteEquipment,
    fetchEquipments,
    isLoading,
    onClose,
    equipment,
    toggleLoading
}) => {
    
    const handleDelete = async () => {
        const clientId = equipment.clientId;

        let isDeleted;

        if (!isLoading) {
            toggleLoading(true);
            isDeleted = await deleteEquipment(equipment.equipmentId, equipment.siteId, clientId);
        }

        if (isDeleted) handleClose(isDeleted);
    };

    const handleClose = (isDeleted) => {
        const body = {};
        clearErrors();
        toggleLoading(false);
        if (isDeleted) fetchEquipments(body);
        onClose();
    };

    return (
        <React.Fragment>
            <ErrorOutlineIcon className={classes.warningIcon} />
            <div className={classes.text}>
                <p className={classes.desc}> Are you sure you want to delete the entity below?</p>
                <p className={classes.name}>Equipment</p>
                <p className={classes.entityName}>{equipment.equipmentName}</p>
            </div>
            <Button
                className={classes.Button}
                onClick={onClose}
                variant="contained"
            >
                Cancel
            </Button>
            <BobConfirmButton
                className={classes.ButtonWithMargin}
                isLoading={isLoading}
                label={'Yes'}
                onClick={handleDelete}
            />
        </React.Fragment>
    );
};


DeleteEquipmentModal.propTypes = {
    onClose: func.isRequired
};

const mapStateToProps = state => {
    return {
        isLoading: state.ui.isLoading
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteEquipmentModal);
